import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import type { NotificationStreamEvent } from '@/api/notificationStream';
import { useNotificationStream } from '@/hooks/useNotificationStream';
import { applyStreamEvent } from './cache';

/** Feeds live stream events into the bell caches while `enabled`. */
export function useNotificationLiveUpdates(enabled: boolean) {
  const client = useQueryClient();
  const onNotification = useCallback(
    (event: NotificationStreamEvent) => applyStreamEvent(client, event),
    [client],
  );

  return useNotificationStream({ enabled, onNotification });
}
